import { render, staticRenderFns } from "./InventoryLocatedCaptureDetail.vue?vue&type=template&id=2d0ab476&scoped=true"
import script from "./InventoryLocatedCaptureDetail.vue?vue&type=script&lang=js"
export * from "./InventoryLocatedCaptureDetail.vue?vue&type=script&lang=js"
import "./InventoryLocatedCaptureDetail.vue?vue&type=style&index=0&id=2d0ab476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0ab476",
  null
  
)

export default component.exports